import axios from 'axios';
import { getApiBaseUrl } from '../auth/apiBaseUrl';

const API_URL = getApiBaseUrl();

export const forgotpassword = async (emailAddress) => {
  try {
    const response = await axios.post(
      `${API_URL}/User/forgot-password?emailAddress=${encodeURIComponent(emailAddress)}`
    );

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Request failed:', response.data);
      throw new Error('Request failed');
    }
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;

    throw new Error(errorMessage);
  }
};

export const otpVerification = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/User/otp-verification`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Request failed:', response.data);
      throw new Error('Request failed');
    }
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;

    throw new Error(errorMessage);
  }
};

export const resetPassword = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/User/reset-password`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Request failed:', response.data);
      throw new Error('Request failed');
    }
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;

    throw new Error(errorMessage);
  }
};

export const resendOtp = async ({ emailAddress, emailTemplate }) => {
  try {
    const url = `${API_URL}/User/resend-otp?emailAddress=${encodeURIComponent(
      emailAddress
    )}&emailTemplate=${encodeURIComponent(emailTemplate)}`;
    const response = await axios.post(url);

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Request failed:', response.data);
      throw new Error('Request failed');
    }
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    throw new Error(errorMessage);
  }
};
